<ng-container *ngIf="assetUsageRights$ | async as usageRights">
  <mat-accordion *ngIf="usageRights.length" multi togglePosition="before" class="asset-area w-full">
    <div class="related-assets-group mb-1" *ngFor="let usageRight of usageRights; let i = index">
      <mat-expansion-panel *ngIf="usageRight" [expanded]="true" class="!mb-2">
        <mat-expansion-panel-header matRipple collapsedHeight="2.5rem" expandedHeight="2.5rem">
          <mat-panel-title class="text-2xl"
            ><span class="title-prefix" i18n>Buyout rights:</span>&nbsp;<span class="title-suffix">{{ usageRight['buyoutRightsTitle'] || '' | optionsLabel: buyoutRights }}</span></mat-panel-title
          >
          <ng-container
            *ngTemplateOutlet="
              actionButton;
              context: {
                $implicit: { edit: true, delete: true },
                usageRightObj: { _id: usageRight['_id'], name: usageRight['buyoutRightsTitle'] | optionsLabel: buyoutRights },
                type: 'editBuyouts',
                index: i,
              }
            "
          ></ng-container>
        </mat-expansion-panel-header>
        <div class="w-full formField-viewer py-4">
          <div class="section mx-2 mb-8">
            <h3 class="text-xl font-semibold mb-4" *ngIf="usageRight['buyoutRightsTitle'] !== notesColumnName" i18n>General info</h3>
            <div class="general-info-details" *ngIf="buyoutRightsConfigs[usageRight['buyoutRightsTitle']]">
              <ng-container *ngFor="let buyoutRightsConfig of buyoutRightsConfigs[usageRight['buyoutRightsTitle']]">
                <header class="general-info-details-header" *ngIf="buyoutRightsConfig.fieldType === 'label'">
                  <h4 class="general-info-details-label text-base !font-bold">{{ buyoutRightsConfig.fieldLabel }}</h4>
                </header>

                <ng-template
                  [ngIf]="
                    usageRight[buyoutRightsConfig.formFieldName || ''] &&
                    (buyoutRightsConfig.fieldType !== 'multiSelectChip' || (buyoutRightsConfig.fieldType === 'multiSelectChip' && usageRight[buyoutRightsConfig.formFieldName][0]))
                  "
                >
                  <div class="general-info-details-entry" [ngClass]="{ 'w-full': buyoutRightsConfig.fieldType === 'textarea' }">
                    <h4 class="general-info-details-label" [ngClass]="{ 'w-1/4': buyoutRightsConfig.fieldType === 'textarea' }">{{ buyoutRightsConfig.fieldLabel }}</h4>
                    <div
                      class="general-info-details-value fill-available-space"
                      *ngIf="buyoutRightsConfig.fieldType === 'textarea'"
                      [innerHTML]="usageRight[buyoutRightsConfig.formFieldName || '']"
                    ></div>
                    <div class="general-info-details-value" *ngIf="buyoutRightsConfig.fieldType === 'multiSelectChip'">
                      <div class="flex row items-start gap-1" *ngIf="usageRight[buyoutRightsConfig.formFieldName]">
                        <ng-template ngFor let-multiSelectField let-i="index" [ngForOf]="usageRight[buyoutRightsConfig.formFieldName]">
                          {{ (i > 0 ? ', ' : '') + (multiSelectField | optionsLabel: buyoutRightsConfig.options) }}
                        </ng-template>
                      </div>
                    </div>
                    <div class="general-info-details-value" *ngIf="buyoutRightsConfig.fieldType !== 'multiSelectChip' && buyoutRightsConfig.fieldType !== 'textarea'">
                      {{ usageRight[buyoutRightsConfig.formFieldName || ''] | optionsLabel: buyoutRightsConfig.options | spDateFormat: { isSafe: true, plainDate: true } }}
                    </div>
                  </div>
                </ng-template>
              </ng-container>
            </div>
          </div>

          <div class="section mx-2 mb-8" *ngIf="columns.length > 0">
            <h3 class="text-xl font-semibold my-4" i18n>Buyout rights</h3>
            <table class="table border-separate border-spacing-y-2 w-full">
              <th class="table-header-group font-bold text-left">
                <tr class="table-row">
                  <ng-container *ngFor="let col of columns">
                    <td class="table-cell px-3">{{ col.header }}</td>
                  </ng-container>
                </tr>
              </th>
              <ng-container *ngFor="let buyoutRight of usageRight['buyoutRights']">
                <ng-container
                  *ngTemplateOutlet="
                    territoryRowTemplate;
                    context: {
                      $implicit: buyoutRight,
                      columns: columns,
                      rowClass: '',
                    }
                  "
                ></ng-container>
              </ng-container>
              <tr class="table-row" *ngIf="usageRight['unmatchedBuyoutRights']?.length">
                <td class="table-cell text-lg font-semibold w-full" colspan="4" i18n>
                  These license regions and expiry dates apply only to some of the selected assets but not all and therefore can't be edited.
                </td>
              </tr>
              <ng-container *ngFor="let buyoutRight of usageRight['unmatchedBuyoutRights']">
                <ng-container
                  *ngTemplateOutlet="
                    territoryRowTemplate;
                    context: {
                      $implicit: buyoutRight,
                      columns: columns,
                      rowClass: 'text-[#1212128f]',
                    }
                  "
                ></ng-container>
              </ng-container>
            </table>
          </div>
        </div>
      </mat-expansion-panel>
    </div>
  </mat-accordion>
</ng-container>

<ng-container *ngIf="assetMakeOSBuyoutRights$ | async as makeBuyoutRights">
  <mat-accordion *ngIf="makeBuyoutRights.length" multi togglePosition="before" class="asset-area w-full">
    <div class="related-assets-group mb-1" *ngFor="let makeBuyoutRight of makeBuyoutRights; let i = index">
      <mat-expansion-panel *ngIf="makeBuyoutRight" [expanded]="true" class="!mb-2">
        <mat-expansion-panel-header matRipple collapsedHeight="2.5rem" expandedHeight="2.5rem">
          <mat-panel-title class="text-2xl"
            ><span class="title-prefix" i18n>Buyout rights:</span>&nbsp;<span class="title-suffix">{{
              makeBuyoutRight['buyoutRightsTitle'] || '' | optionsLabel: buyoutRightsMakeOS
            }}</span></mat-panel-title
          >
          <ng-container
            *ngTemplateOutlet="
              actionButton;
              context: {
                $implicit: { edit: true, delete: true },
                usageRightObj: { _id: makeBuyoutRight['_id'], name: makeBuyoutRight['buyoutRightsTitle'] | optionsLabel: buyoutRights },
                type: 'editBuyouts',
                index: i,
              }
            "
          ></ng-container>
        </mat-expansion-panel-header>
        <div class="w-full formField-viewer py-4">
          @for (buyoutRight of makeBuyoutRight['buyoutRights']; let i = $index; track i) {
            <ng-container *ngTemplateOutlet="buyoutRightTemplate; context: { buyoutRight: buyoutRight, index: i, makeBuyoutRight: makeBuyoutRight }"></ng-container>

            <div class="section mx-2 mb-4" *ngIf="columns.length > 0">
              <table class="table border-separate border-spacing-y-2 w-full">
                <th class="table-header-group font-bold text-left">
                  <tr class="table-row">
                    <ng-container *ngFor="let col of columns">
                      <td class="table-cell px-3" [ngClass]="col.class">
                        @if (col['columnDef'] === 'media') {
                          {{ col.header }}
                          <mat-icon
                            class="text-[#1212128F] text-[1.4rem] cursor-pointer align-bottom"
                            i18n-matTooltip
                            [matTooltip]="'For more info about the exact scope please check in edit mode or contact your support.'"
                            >info</mat-icon
                          >
                        } @else {
                          {{ col.header }}
                        }
                      </td>
                    </ng-container>
                  </tr>
                </th>
                <ng-container *ngFor="let territory of buyoutRight['territories']">
                  <ng-container
                    *ngTemplateOutlet="
                      territoryRowTemplate;
                      context: {
                        $implicit: territory,
                        columns: columns,
                        rowClass: '',
                      }
                    "
                  ></ng-container>
                </ng-container>
                <tr class="table-row" *ngIf="makeBuyoutRight['unmatchedBuyoutRights']?.length">
                  <td class="table-cell text-lg font-semibold w-full" colspan="4" i18n>
                    These license regions and expiry dates apply only to some of the selected assets but not all and therefore can't be edited.
                  </td>
                </tr>
                <ng-container *ngFor="let buyoutRight of makeBuyoutRight['unmatchedBuyoutRights']">
                  <ng-container
                    *ngTemplateOutlet="
                      territoryRowTemplate;
                      context: {
                        $implicit: buyoutRight,
                        columns: columns,
                        rowClass: 'text-[#1212128f]',
                      }
                    "
                  ></ng-container>
                </ng-container>
              </table>
            </div>
          }
        </div>
      </mat-expansion-panel>
    </div>
  </mat-accordion>
</ng-container>

<ng-container *ngIf="CustomClients.SEAT !== this.brandingKey">
  <mat-accordion multi togglePosition="before" class="asset-area w-full">
    <mat-expansion-panel class="!mb-2">
      <mat-expansion-panel-header matRipple collapsedHeight="2.5rem" expandedHeight="2.5rem">
        <mat-panel-title class="text-2xl" i18n>Notes</mat-panel-title>
        <ng-container *ngTemplateOutlet="actionButton; context: { $implicit: { edit: true, delete: false }, type: 'editNotes' }"></ng-container>
      </mat-expansion-panel-header>
      <div class="w-full formField-viewer py-4" *ngIf="assetNotes$ | async as assetNotes">
        <div class="section mx-2">
          <div [innerHTML]="assetNotes"></div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</ng-container>

<ng-container *ngIf="unMatchedUsageRight$ | async as unMatchedUsageRight">
  <mat-accordion *ngIf="unMatchedUsageRight.length" multi togglePosition="before" class="asset-area w-full">
    <div class="text-lg font-semibold mt-4 mb-3">These buyout rights apply only to some of the selected assets but not all and therefore can't be edited.</div>
    <div class="related-assets-group mb-1" *ngFor="let usageRight of unMatchedUsageRight; let i = index">
      <mat-expansion-panel *ngIf="usageRight" class="!mb-2 custom-disabled-panel">
        <mat-expansion-panel-header matRipple collapsedHeight="2.5rem" expandedHeight="2.5rem">
          <mat-panel-title class="text-2xl">
            <span class="title-prefix" i18n>Buyout rights:</span>&nbsp;<span class="title-suffix">{{ usageRight || '' | optionsLabel: buyoutRights }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
    </div>
  </mat-accordion>
</ng-container>

<ng-template #actionButton let-buttonsVisibility let-usageRightObj="usageRightObj" let-type="type" let-index="index">
  <div>
    <button
      *ngIf="buttonsVisibility.edit"
      (click)="editBuyoutRights(type, index, usageRightObj?._id); $event.stopPropagation()"
      [disabled]="!(AnyAsset | can: 'usagerights')"
      class="icon-button-narrow cursor-pointer"
      mat-icon-button
      role="button"
      i18n-matTooltip
      matTooltip="Edit buyout rights"
    >
      <mat-icon class="material-icons-outlined">edit</mat-icon>
    </button>
    <button
      *ngIf="buttonsVisibility.delete"
      (click)="deleteBuyoutRights(usageRightObj); $event.stopPropagation()"
      [disabled]="!(AnyAsset | can: 'usagerights')"
      class="icon-button-narrow cursor-pointer"
      mat-icon-button
      role="button"
      i18n-matTooltip
      matTooltip="Delete buyout rights"
    >
      <mat-icon class="material-icons-outlined">delete</mat-icon>
    </button>
  </div>
</ng-template>

<ng-template #buyoutRightTemplate let-buyoutRight="buyoutRight" let-i="index" let-makeBuyoutRight="makeBuyoutRight">
  <div class="section mx-2 mb-4" [ngClass]="{ 'border-t-2 pt-3': i !== 0 }">
    <h3 class="text-xl font-semibold mb-4" *ngIf="buyoutRight.subLevelType">
      {{ buyoutRight.subLevelType | optionsLabel: buyoutRightsMakeOSSecondLevel }}
    </h3>
    <h3 class="text-xl font-semibold mb-4" *ngIf="!buyoutRight.subLevelType">
      {{ makeBuyoutRight['buyoutRightsTitle'] | optionsLabel: buyoutRightsMakeOS }} {{ makeBuyoutRight['buyoutRightsTitle'] === 'cast' ? 'member' : '' }} #{{ i + 1 }}
    </h3>
    <div class="general-info-details">
      <ng-container *ngFor="let buyoutRightsConfig of buyoutRightsConfigs[buyoutRight.subLevelType || makeBuyoutRight['buyoutRightsTitle']]">
        <ng-container *ngIf="buyoutRightsConfig.fieldType !== 'checkbox' && buyoutRight[buyoutRightsConfig.formFieldName]">
          <div class="general-info-details-entry">
            <h4 class="general-info-details-label">{{ buyoutRightsConfig.fieldLabel }}</h4>
            <div class="general-info-details-value" *ngIf="buyoutRightsConfig.fieldType === 'text'">{{ buyoutRight[buyoutRightsConfig.formFieldName] }}</div>
            <div class="general-info-details-value" *ngIf="buyoutRightsConfig.fieldType === 'textarea'" [innerHTML]="buyoutRight[buyoutRightsConfig.formFieldName]"></div>
          </div>
        </ng-container>
        <div class="checkbox-specific" *ngIf="buyoutRightsConfig.fieldType === 'checkbox' && buyoutRight[buyoutRightsConfig.formFieldName]">
          <mat-checkbox class="w-full" disabled [checked]="buyoutRight[buyoutRightsConfig.formFieldName]"></mat-checkbox>
          <div class="general-info-details-label">{{ buyoutRightsConfig.fieldLabel }}</div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #territoryRowTemplate let-item let-columns="columns" let-rowClass="rowClass">
  <tr
    class="table-row shadow-[0_3px_10px_rgb(0,0,0,0.2)] rounded-lg"
    [ngClass]="rowClass"
    [ngClass]="{ '!shadow-[0_3px_10px_rgb(0,0,0,0.2),_inset_0_0_0_99rem_#f5dfd8]': !(item.expiryDate | dateNotExpired) }"
  >
    <ng-container *ngFor="let col of columns">
      <td class="table-cell p-3 align-top" *ngIf="col['columnDef'] !== 'expiryDate'; else expiryDate">
        <ng-container *ngIf="col['columnDef'] === 'territory' || col['columnDef'] === 'media'; else renderOtherColumns">
          <ng-container *ngIf="buyoutUtilsService.mediaAndTerritoryFormatting(item[col['columnDef']], col) as formattedData">
            <div *ngFor="let data of formattedData">
              {{ data.finalSelectedValuesArray | optionsLabel: col['options'] }}
              <ng-container *ngIf="data.finalExcludedValues.length > 0"> (excl. {{ data.finalExcludedValues | optionsLabel: col['options'] }})</ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="buyoutUtilsService.independentSelectedMediaAndTerritoryFormatting(item[col['columnDef']], col) as formattedData">
            <ng-container *ngIf="formattedData?.length">
              <ng-container *ngFor="let data of formattedData; let last = last">{{ data | optionsLabel: col['options'] }}<span *ngIf="!last">, </span> </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>

        <ng-template #renderOtherColumns>
          {{ item[col['columnDef']] | optionsLabel: col['options'] | spDateFormat: { isSafe: true, plainDate: true } }}
        </ng-template>
      </td>
      <ng-template #expiryDate>
        <td class="table-cell p-3 align-top" *ngIf="item[col['columnDef']]; else noExpiryDate" [ngClass]="{ 'text-[#bf360c]': !(item[col['columnDef']] | dateNotExpired) }">
          {{ item[col['columnDef']] | spDateFormat: { isSafe: true, plainDate: true } }}
        </td>
        <ng-template #noExpiryDate>
          <td class="table-cell p-3 align-top" i18n>No Expiry date</td>
        </ng-template>
      </ng-template>
    </ng-container>
  </tr>
</ng-template>
